import moment from 'moment';

const typeUtils = {
    isObject: function (arg) {
        return typeof arg === 'object' && arg instanceof Object && arg !== null;
    },
    isEmptyObject: function (arg) {
        return this.isObject(arg) && Object.keys(arg).length === 0;
    },
    isString: function (arg) {
        return typeof arg === 'string';
    },
    isNumber: function (arg) {
        return typeof arg === 'number' && !(isNaN(arg));
    },
    isBoolean: function(arg){
        return typeof arg === 'boolean';
    },
    isValidString: function (arg) {
        return (typeof arg === 'string' && arg.trim().length > 0);
    },
    isEmptyString: function (arg) {
        return (typeof arg === 'string' && arg.trim().length === 0);
    },
    isFunction: function(arg) {
        return (arg instanceof Function && typeof arg === 'function');
    },
    isDefined: function(arg){
        return (arg !== null && arg !== undefined && typeof arg !== 'undefined');
    },
    isValidDate: function(date){
        return (typeof date !== 'undefined' && moment(date).format() !== 'Invalid date');
    },
};

export default typeUtils;